// extracted by mini-css-extract-plugin
export default {"page":"Solution_page__Vz520"};